import { LanguageType } from "@/enums/enums";
import { GetLanguageType } from "@/helper/userHelper";
import { UnitModel } from "@/model/unit/unitModel";
export function ConvertToUnit(unitRawList: any): Array<UnitModel> {
  const unitList: Array<UnitModel> = [];
  if (unitRawList && unitRawList.length > 0) {
    for (const unitRaw of unitRawList) {
      const unit: UnitModel = {
        id: unitRaw.id,
        unitType: unitRaw.unitType,
        unitCode: unitRaw.unitCode,
        nameTh: unitRaw.nameTh,
        nameEng: unitRaw.nameEng,
        name: GetLanguageType() == LanguageType.En ? unitRaw.nameEng : unitRaw.nameTh,
        isMain: unitRaw.isMain,
        isDeleted: unitRaw.isDeleted,
      };
      unitList.push(unit);
    }
  }
  return unitList;
}
